import { useFeatureGate } from '@trello/feature-gate-client';

export const useShouldUseAccessibleProducts = () => {
  const { value } = useFeatureGate('trello_xf_use_accessible_products');
  return Boolean(value);
};
